import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { LoyaltyOffer } from '../../../types/modules/admin/loyaltyOffer.type'
import { CustomDate } from '../../../utils/day'
import ToggleSwitch from '../../ui/ToggleSwitch'
import { useUpdateResource } from '../../../hooks/useUpdateResource'
import UpdateLoyaltyOfferForm from './UpdateLoyaltyOfferForm'
import { formatNumber } from '../../../utils/formatNumber'
import DateTimeText from '../../ui/DateTimeText'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    item:LoyaltyOffer
}

function LoyaltyOfferItem({item}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const [isActive,setIsActive] = useState(item.isActive);
        const {t}= useTranslation();

        const {updateResource} = useUpdateResource();

         async function handleChangeActive(){
              setIsActive(p=>!p);
              await  updateResource(`loyalty-offer/${item.id}/toggle`, {}, "admin",{
                  method: "PATCH",
                  invalidateQueries:["loyalty-offers-by-admin"],
            });
            }


  return (
    <>
     <td className="p-3 min-w-[100px] text-Black font-normal text-justify">
        {formatNumber(item.id)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {formatNumber(item.amountRequired)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {formatNumber(item.bonusAmount)}
        </td>

        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        <DateTimeText date={item.startDate??""}/>
        </td>

         <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
            <DateTimeText date={item.endDate??""}/>
        </td>

        <PermissionGate permissions={[PermissionsKey.UpdateLoyaltyOffer]}>
             <td className="p-3 min-w-[100px] text-Black font-normal text-justify">
            <ToggleSwitch checked={isActive} size="sm" onChange={()=>{handleChangeActive()}}/>
            </td>

            <td className="p-3 min-w-[100px] text-Black font-normal text-justify">
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
            </td>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateLoyaltyOfferForm
            defaultValues={{
            startDate:item.startDate,
            endDate:item.endDate,
            amountRequired:item.amountRequired,
            bonusAmount:item.bonusAmount
        }}
        id={item.id}
        onSubmitSuccess={() => {
            setIsOpen(p=>false);
  }}
        />
        </CustomModal>
    </>
  )
}

export default LoyaltyOfferItem